/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { boolean as codecBoolean, optional as codecOptional } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { CodeQualityBaseData } from './CodeQualityBaseData';
const CodeQualityDataParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    [
        'ignoreFilesNotFound',
        /* #__PURE__ */ codecOptional(codecBoolean),
        'ignore_files_not_found',
    ],
]), CodeQualityBaseData);
export class CodeQualityData extends CodeQualityBaseData {
    static decode(input) {
        return CodeQualityDataParser.decode(input).map(res => new CodeQualityData(res));
    }
    static unsafeDecode(input) {
        return CodeQualityData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CodeQualityDataParser.encode(data);
    }
    static schema() {
        return CodeQualityDataParser.schema();
    }
}
